<script lang="ts">
	import ChromosomeHero from "@components/ChromosomeHero.svelte";
	import HpHero from "@components/HpHero.svelte";
	import Manufacturers from "@components/Manufacturers.svelte";
	import ProductCategoryHeros from "@components/ProductCategoryHeros.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import type { HomepageProps } from "./HomepageProps.js";

	const { subcategories }: HomepageProps = $props();
</script>

<Layout headerBgAnimation>
	<HpHero />
	<ChromosomeHero />
	<Manufacturers />
	<ProductCategoryHeros {subcategories} />
</Layout>
